import { TextFieldElement } from 'react-hook-form-mui';

import { useCurrentProduct } from 'api/products';

export function AdditionalLicenseData({ name = 'additionalLicenseData', disabled = false }) {
    const { data: currentProduct } = useCurrentProduct();
    const validateAdditionalLicenseData = value => {
        const text = typeof value === 'string' ? value : '';
        if (text) {
            try {
                const result = JSON.parse(text);
                if (typeof result !== 'object') {
                    // JSON.parse also accepts input that is valid JSON, but
                    // not an object.
                    throw new SyntaxError();
                }

                return true;
            } catch {
                return 'Must be a valid JSON object';
            }
        }

        return true;
    };

    if (!currentProduct?.allow_additional_license_data) return null;

    return (
        <TextFieldElement
            name={name}
            label="Additional License Data"
            multiline
            disabled={disabled}
            autoComplete="off"
            variant="outlined"
            rules={{
                validate: validateAdditionalLicenseData,
            }}
        />
    );
}
